import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState, type ReactNode } from "react";
import { ExplorerProvider } from "../context/ExplorerContext";
import "../../design-system/styles/theme.css";
import "../../design-system/styles/globals.css";

/**
 * Providers required by the microservices module. The host mounts this once
 * as an "islands" layout wrapper around <Outlet/>. It gives the module its
 * OWN QueryClient scope so mutations/invalidations here don't churn the
 * host app's caches.
 *
 * The host should NOT re-wrap in <AuthProvider/> — the module reads the
 * host's user via `useHostAuth()` (see integration docs) once the
 * `installAuthorizedFetch()` call has been made at bootstrap.
 */
export function MicroservicesProviders({ children }: { children: ReactNode }) {
  const [client] = useState(() => new QueryClient({
    defaultOptions: {
      queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 },
    },
  }));
  return (
    <QueryClientProvider client={client}>
      <ExplorerProvider>{children}</ExplorerProvider>
    </QueryClientProvider>
  );
}
